import React, { CSSProperties } from 'react';
import { MdAutoAwesome, MdWbSunny, MdBlurOn, MdBlurOff, MdBrightness6 } from 'react-icons/md';

export const QualityAnalysis = ({ data }) => {
  const styles: Record<string, CSSProperties> = {
    card: {
      width: '100%',
      backgroundColor: '#ffffff',
      borderRadius: '24px',
      border: '1px solid #E8EDF2',
      padding: '24px',
      boxShadow: '0 1px 3px rgba(0, 0, 0, 0.05)',
      fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
      boxSizing: 'border-box',
      marginTop: '24px',
    },
    header: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      marginBottom: '32px',
    },
    headerLeft: {
      display: 'flex',
      alignItems: 'center',
      gap: '16px',
    },
    iconMainContainer: {
      width: '52px',
      height: '52px',
      borderRadius: '16px',
      backgroundColor: '#EEF2FF',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },
    title: {
      margin: 0,
      color: '#0F172A',
      fontSize: '18px',
      fontWeight: '700',
    },
    subtitle: {
      margin: 0,
      color: '#94A3B8',
      fontSize: '14px',
      marginRight: '24px',
    },
    scoreBadge: {
      backgroundColor: '#F0F5FF',
      padding: '6px 12px',
      borderRadius: '8px',
    },
    scoreText: {
      color: '#4F6EF7',
      fontWeight: '700',
      fontSize: '15px',
    },
    grid: {
      display: 'grid',
      gridTemplateColumns: 'repeat(3, 1fr)',
      gap: '16px',
    },
    box: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '20px 0',
      borderRadius: '16px',
      border: '1px solid',
      transition: 'all 0.3s ease',
    },
    label: {
      fontSize: '13px',
      fontWeight: '600',
      marginTop: '8px',
    }
  };
  const photoData = {
    qualityScore: Math.round(data?.blur_variance || 0),
    isBlurry: data?.is_blurry,
    isLightingOk: data?.brightness_status === "ok",
    isContrastOk: !data?.low_contrast,
  };
  return (
    <div style={styles.card}>
      {/* Header Section */}
      <div style={styles.header}>
        <div style={styles.headerLeft}>
          <div style={styles.iconMainContainer}>
            <MdAutoAwesome size={28} color="#4F6EF7" />
          </div>
          <div>
            <h3 style={styles.title}>Analyse de qualité</h3>
            <p style={styles.subtitle}>Basé sur le dernier cliché</p>
          </div>
        </div>
        <div
          style={{
            ...styles.scoreBadge,
            backgroundColor: data.overall_quality === "accept" ? '#F0F5FF' : '#FFE5E5',
          }}
        >
          <span
            style={{
              ...styles.scoreText,
              color: data.overall_quality === "accept" ? '#4F6EF7' : '#FF5252'
            }}
          >
            {data.overall_quality === "accept" ? "Acceptable" : "Reprendre la photo"}
          </span>
        </div>
      </div>

      {/* Indicators Grid */}
      <div style={styles.grid}>
        
        {/* BLUR INDICATOR */}
        <div style={{
          ...styles.box,
          backgroundColor: photoData.isBlurry ? '#FFF5F5' : '#F8FAFC',
          borderColor: photoData.isBlurry ? '#FFDADA' : '#F1F5F9'
        }}>
          <div style={{ display: 'flex' }}>
            {photoData.isBlurry ? (
              <MdBlurOn size={26} color="#FF5252" />
            ) : (
              <MdBlurOff size={26} color="#22C55E" />
            )}
          </div>
          <span style={{ 
            ...styles.label, 
            color: photoData.isBlurry ? '#FF5252' : '#64748B' 
          }}>
            {photoData.isBlurry ? "Flou" : "Net"}
          </span>
        </div>

        {/* LIGHTING INDICATOR */}
        <div style={{ 
          ...styles.box, 
          backgroundColor: !photoData.isLightingOk ? '#FFF5F5' : '#F8FAFC', 
          borderColor: !photoData.isLightingOk ? '#FFDADA' : '#F1F5F9' 
        }}>
          <MdWbSunny size={26} color={photoData.isLightingOk ? "#22C55E" : "#FF5252"} />
          <span style={{ 
            ...styles.label, 
            color: !photoData.isLightingOk ? '#FF5252' : '#64748B' 
          }}>Lumière</span>
        </div>

        {/* CONTRAST INDICATOR */}
        <div style={{ 
          ...styles.box, 
          backgroundColor: !photoData.isContrastOk ? '#FFF5F5' : '#F8FAFC', 
          borderColor: !photoData.isContrastOk ? '#FFDADA' : '#F1F5F9' 
        }}>
          <MdBrightness6 size={26} color={photoData.isContrastOk ? "#22C55E" : "#FF5252"} />
          <span style={{ 
            ...styles.label, 
            color: !photoData.isContrastOk ? '#FF5252' : '#64748B' 
          }}>Contraste</span>
        </div>

      </div>
    </div>
  );
};